import React from 'react'
import '../index.css'
import { Box, Grid2, Paper, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

const Footer = () => {
    return (
        <Paper elevation={1} className="" sx={{ backgroundColor: '#4DA235' }}>

            <Grid2 container sx={{padding:2}}>
                <Grid2 size={3} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Box sx={{ display: 'flex',alignItems:'center', justifyContent: 'center', marginRight:2 }}>
                        <Typography color='white'>Copyright © 2024</Typography>
                    </Box>
                    <Box sx={{ display: 'flex',alignItems:'center', justifyContent: 'center' }}>
                        <Typography color='white'>Briezi</Typography>
                    </Box>
                </Grid2>
                <Grid2 size={6}></Grid2>
                <Grid2 size={3} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex',alignItems:'center', justifyContent: 'center', marginRight:2 }}>
                        <Typography color='white'>Privacy Policy</Typography>
                    </Box>
                    <Box sx={{ display: 'flex',alignItems:'center', justifyContent: 'center' }}>
                        <Typography color='white'>Terms & Conditions</Typography>
                    </Box>
                </Grid2>
            </Grid2>
        </Paper>
    )
}

export default Footer;
